"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapIndexRecord = void 0;
function mapIndexRecord(record, mapFn) {
    const next = {};
    Object.entries(record).forEach(([idx, c]) => {
        const iIdx = Number(idx);
        if (Number.isSafeInteger(iIdx)) {
            next[iIdx] = mapFn(c, iIdx);
        }
    });
    return next;
}
exports.mapIndexRecord = mapIndexRecord;
//# sourceMappingURL=mapIndexRecord.js.map